var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgDAhuGeneralRoomUnitT = function SvgDAhuGeneralRoomUnitT(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "0 0 684 480",
    xmlSpace: "preserve",
    enableBackground: "new 0 0 684 480"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M551.1,88.5c-5.8,0-10.5-4.7-10.5-10.5s4.7-10.5,10.5-10.5s10.5,4.7,10.5,10.5S556.9,88.5,551.1,88.5z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551.1,68c5.5,0,10,4.5,10,10s-4.5,10-10,10s-10-4.5-10-10S545.6,68,551.1,68 M551.1,67c-6.1,0-11,4.9-11,11 s4.9,11,11,11s11-4.9,11-11S557.2,67,551.1,67L551.1,67z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M553.5,75.4h-1.8v4.9h-1v-4.9H549v-0.8h4.5V75.4z"
  })))));
};
export default SvgDAhuGeneralRoomUnitT;